var ConditionItemModel = /** @class */ (function () {
    function ConditionItemModel(index, conditionType, condition, relationType) {
        this.index = index;
        this.conditionType = conditionType;
        this.condition = condition;
        this.relationType = relationType;
    }
    return ConditionItemModel;
}());
export { ConditionItemModel };
